import React from "react";
import { Col, Row } from "react-bootstrap";
import "./aboutme.css";
import { useHistory } from "react-router-dom";
import Cookies from "universal-cookie";
import { connect } from "react-redux";
import Bio from "./Bio";
import Background from "./Background";
import Suggestion from "./Suggestion";

const Cookie = new Cookies();

function Aboutme({ rootData }) {
  let history = useHistory();
  var token = Cookie.get("wmtoken");
  const backToLoginPage = () => {
    history.push("/login");
  };
  const getDetailCard = (view) => {
    history.push(`/posts#${view}`);
  };
  return token ? (
    <React.Fragment>
      <React.Fragment>
        {rootData.bio && (
          <Bio className="mb-4 bg-white" biocontent={rootData.bio} />
        )}
        {rootData.educationData?.length > 0 ||
        rootData.workData?.length > 0 ||
        rootData.certificatedata?.length > 0 ||
        rootData.projectdata?.length > 0 ||
        rootData.extraCurdata?.length > 0 ||
        rootData.publicationdata?.length > 0 ? (
          <Background className="mb-4" data={rootData} />
        ) : (
          ""
        )}
        <Row>
          <Col md={6}>
            <div
              onClick={() => getDetailCard("blogs")}
              className="blogCount w-full py-4 text-center border shadow rounded bg-white cursor-pointer no-underline"
            >
              <span className="block text-5xl mb-2 text-black manpro font-semibold">
                {rootData.blogCount}
              </span>
              <span className="block text-xl text-black manpro font-medium">
                Blogs
              </span>
            </div>
          </Col>
          <Col md={6}>
            <div
              onClick={() => getDetailCard("questions")}
              className="questionCount w-full py-4 text-center border shadow rounded bg-white cursor-pointer no-underline"
            >
              <span className="block text-5xl mb-2 text-black manpro font-semibold">
                {rootData.questionCount}
              </span>
              <span className="block text-xl text-black manpro font-medium">
                Questions
              </span>
            </div>
          </Col>
        </Row>
        {/* <Suggestion className="my-4" /> */}
      </React.Fragment>
    </React.Fragment>
  ) : (
    backToLoginPage()
  );
}
const mapStateToProps = (state) => {
  return state;
};

export default connect(mapStateToProps, null)(Aboutme);
